import React from "react";
import ReactECharts from "echarts-for-react";
import ChartCard from "../ChartCard";
import { COLORS } from "../../mockData";

const BAR_COLOR = "#0B92FE";

const SeverityDistGAD7 = ({ data, loading, onCardClick }) => {
  const chart = data?.charts?.find((c) => c.assessment === "GAD-7");

  if (!chart && !loading) return null;

  const categories = chart?.xAxis || [];
  const values = chart?.yAxis || [];

  const handleChartClick = (params) => {
    if (!onCardClick || params.componentType !== "series") return;
    onCardClick({
      cardType: "severityDistribution",
      assessmentType: "gad7",
      timeRange: chart?.timeRange,
      viewType: "included",
      severity: params.name,
      sectionTitle: chart?.title || "Severity Distribution (GAD-7)",
      cardLabel: "GAD-7",
    });
  };

  const option = {
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
    },
    grid: {
      left: "3%",
      right: "6%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLine: { lineStyle: { color: COLORS.border } },
      splitLine: { lineStyle: { color: COLORS.border, type: "dashed" } },
      axisLabel: { color: COLORS.body, fontSize: 11 },
    },
    yAxis: {
      type: "category",
      data: categories,
      axisLine: { lineStyle: { color: COLORS.border } },
      axisLabel: { color: COLORS.body, fontSize: 11, width: 100 },
    },
    series: [
      {
        type: "bar",
        barWidth: 18,
        itemStyle: { color: BAR_COLOR, borderRadius: [0, 4, 4, 0], cursor: onCardClick ? "pointer" : "default" },
        data: values,
        label: {
          show: true,
          position: "right",
          color: COLORS.body,
          fontSize: 11,
        },
      },
    ],
  };

  const chartHeight = Math.max(300, categories.length * 55);

  return (
    <ChartCard
      title={chart?.title || "Severity Distribution (GAD-7)"}
      subtitle={chart?.timeRange || ""}
    >
      <ReactECharts
        option={option}
        style={{ height: chartHeight }}
        onEvents={onCardClick ? { click: handleChartClick } : undefined}
      />
    </ChartCard>
  );
};

export default SeverityDistGAD7;
